import { render, staticRenderFns } from "./grade_list.vue?vue&type=template&id=2c8d5d7a&"
import script from "./grade_list.vue?vue&type=script&lang=js&"
export * from "./grade_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports